<template>
  <div>
    <br />
    <br v-if="!mobile" />
    <!-- toolbar -->
    <p>
      <!-- title -->
      <span style="font-size: 25px">{{ route === 'students' ? 'Students' : 'Admins' }}</span>

      <!-- create new user -->
      <router-link
        :to="{ name: 'createUser', params: { role } }"
        tag="span"
        class="btn waves-effect waves-light indigo"
        style="float: right;"
      >Add new</router-link>

      <!-- get user by role -->
      <router-link
        v-if="!mobile"
        :to="{ name: 'users', params: { role: route === 'students' ? 'admins' : 'students' } }"
        tag="span"
        class="btn waves-effect waves-light amber"
        style="float: right; margin-right: 10px"
      >{{ route === 'students' ? 'Admins' : 'Students' }}</router-link>

      <!-- set search bar visibility -->
      <i
        @click="search = !search"
        class="material-icons small indigo-text"
        style="float: right;  margin-top: 3px; margin-right: 20px"
      >search</i>
    </p>
    <hr />

    <!-- search bar -->
    <div v-if="search" class="container">
      <br />
      <div class="input-field">
        <i class="material-icons prefix">search</i>
        <input id="search" type="text" v-model="query" />
        <label for="search">Serach...</label>
      </div>
    </div>

    <br />

    <!-- user list -->
    <ul
      v-if="search || route === 'students' && students.length !== 0 || route === 'admins' && admins.length !== 0"
      class="collection"
    >
      <li
        v-for="user in search ? results : route === 'students' ? students : admins"
        :key="user._id"
        class="collection-item"
      >
        <!-- users full name  -->
        <router-link
          v-if="role === 'student'"
          :to="{ name: 'student', params: { student: user._id, token: user.token } }"
          tag="a"
        >{{ user.fullName }}</router-link>
        <span v-else>{{ user.fullName }}</span>
        <!-- delete user -->
        <i
          @click="userToDelete = user.token"
          data-target="delete"
          class="material-icons red-text modal-trigger"
          style="float: right"
        >delete</i>
        <!-- update user -->
        <router-link
          v-if="route === 'students'"
          :to="{ name: 'updateUser', params: { user: user.token } }"
          tag="i"
          class="material-icons green-text"
          style="float: right; margin-right: 20px"
        >edit</router-link>
      </li>
    </ul>

    <!-- Modal Structure -->
    <div id="delete" class="modal">
      <div class="modal-content">
        <h5
          class="center red-text"
        >Are you sure you want to delete this {{ route === 'students' ? 'student' : 'admin' }} ?</h5>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="this.delete" class="modal-close waves-effect waves-light btn-flat">Yes</a>
        <a href="#!" class="modal-close waves-effect waves-light btn-flat">No</a>
      </div>
    </div>
    <br v-for="i in 4" :key="i" />
  </div>
</template>


<script>
export default {
  data() {
    return {
      search: false,
      query: "",
      results: [],
      userToDelete: "",
      students: [],
      admins: []
    };
  },
  created() {
    $(document).ready(() => $(".modal").modal());

    this.$store
      .dispatch("getUsers", this.role)
      .then(response => (this[this.role + "s"] = response.data));
  },
  methods: {
    delete() {
      this.$store.dispatch("deleteUser", this.userToDelete).then(response => {
        if (response.data.success) {
          this.$store
            .dispatch("getUsers", this.role)
            .then(response => (this[this.role + "s"] = response.data));

          if (this.$store.getters.getToken === this.userToDelete) {
            // remove token from localStorage
            localStorage.removeItem("token");
            // set auth false
            this.$store.commit("setAuth", false);
            // remove token from vuex
            this.$store.commit("setToken", "");
            // remove user from vuex
            this.$store.commit("setUser", {
              fullName: "",
              role: "",
              level: "",
              lesson: ""
            });
            // redirect to home
            this.$router.push({ name: "home" });
          }

          M.toast({
            html: `${this.role} deleted`,
            classes: "green"
          });
        } else if (response.data.msg) {
          M.toast({
            html: `1 admin should always exist`,
            classes: "amber"
          });
        } else {
          M.toast({
            html: `failed to delete ${this.role}`,
            classes: "red"
          });
        }
      });
    }
  },
  computed: {
    mobile() {
      return window.innerWidth < 420;
    },
    role() {
      return this.route.substring(0, this.route.length - 1);
    },
    route() {
      return this.$route.params.role;
    }
  },
  watch: {
    route() {
      this.$store
        .dispatch("getUsers", this.role)
        .then(response => (this[this.role + "s"] = response.data));
    },
    query() {
      if (this.query.length === 0) this.results = [];
      else
        this.$store
          .dispatch("searchUser", this.query)
          .then(response => (this.results = response.data));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Users.vue